import { InputIconLeftMemoized, InputIconMemoized } from './styles.js';
import { jsx } from 'react/jsx-runtime';

const InputIconLeft = props => /*#__PURE__*/jsx(InputIconLeftMemoized, {
  ...props
});
const InputIcon = props => /*#__PURE__*/jsx(InputIconMemoized, {
  ...props
});

export { InputIcon, InputIconLeft };
//# sourceMappingURL=components.js.map
